import logoHorizontalInverse from '@chukua/common/assets/logo/logo-horizontal-inverse.svg';
import logoHorizontal from '@chukua/common/assets/logo/logo-horizontal.svg';
import markUrl from '@chukua/common/assets/logo/mark.svg';
import { BRAND } from '@chukua/common';
import { useColorMode } from '../theme/ColorModeProvider';

interface LogoProps {
  variant?: 'horizontal' | 'mark';
  height?: number;
  /** `inverse` forces the light-on-dark lockup, for surfaces that are dark in both modes. */
  tone?: 'auto' | 'inverse';
}

/**
 * Brand logo for the current colour mode. `mark` is the truck alone, for tight
 * spaces (collapsed rail). Assets are generated from master.svg — see
 * scripts/sync-logos.py.
 */
export function Logo({ variant = 'horizontal', height = 22, tone = 'auto' }: LogoProps) {
  const { mode } = useColorMode();
  const horizontal = tone === 'inverse' || mode === 'dark' ? logoHorizontalInverse : logoHorizontal;
  const src = variant === 'mark' ? markUrl : horizontal;
  // Inline height, not the attribute: Tailwind's preflight sets `img { height: auto }`, which overrides `height=`.
  return <img src={src} alt={BRAND.name} style={{ height }} className="block w-auto max-w-none" />;
}
